// Route search params, kept apart from the page (2026-10-31): the route file's validateSearch is not code-split, so
// whatever it imports ships in the first-load entry chunk. This file must stay free of React, UI and messages.
/** Steps of the import wizard, in order. The current one lives in `?step=`. */
export const IMPORT_STEPS = ["upload", "map", "duplicates", "progress", "result"] as const;
export type ImportStep = (typeof IMPORT_STEPS)[number];

/** The record types a CSV can be imported into (P31, X4-04). The legacy wizard takes the first five; the tool importers
 *  also write projects, proposals, invoices and time entries, and read clients, contacts, tasks and deals from a tool. */
export const IMPORT_TYPES = ["clients", "contacts", "projects", "tasks", "deals", "proposals", "invoices", "timeEntries", "leads"] as const;
export type ImportType = (typeof IMPORT_TYPES)[number];
